import * as React from 'react';

import { usePageHeaderHeight } from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import type { ProductDiscountPromoBannerProps } from 'bundles/page/types/Program';
import ProductDiscountPromoBanner from 'bundles/promotions/components/ProductDiscountPromoBanner';

type Props = {
  productDiscountPromoBannerProps?: ProductDiscountPromoBannerProps;
};

const BANNER_HEIGHT = 100;

const LegacyProductDiscountPromoBannerWrapper = ({ productDiscountPromoBannerProps }: Props) => {
  const pageHeaderHeightContext = usePageHeaderHeight();

  const addHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }
    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height + BANNER_HEIGHT);
  };

  const removeHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }
    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height - BANNER_HEIGHT);
  };

  return (
    <ProductDiscountPromoBanner
      {...productDiscountPromoBannerProps}
      addParentHeightClass={addHeight}
      removeParentHeightClass={removeHeight}
    />
  );
};

export default LegacyProductDiscountPromoBannerWrapper;
